import { css, type Theme } from '@emotion/react';
import styled from '@emotion/styled';
import { InteractiveText, SecondaryText } from '@silvertours/front-shared';
import { OpeningTimesSchedule } from '../../OpeningTimesSchedule';

const getLayout = ({ theme }: { theme: Theme }) => css`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${theme.mq('lg')} {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    max-width: none;
  }
`;

const Anchor = styled.a`
  color: inherit;
  text-decoration: inherit;
`;

const PopoverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContactInfo = styled.div`
  ${getLayout};
  padding-left: 1rem;
  padding-right: 1rem;
  row-gap: ${({ theme }) => theme.spacing[40]};

  > p:first-of-type {
    width: 100%;
  }
`;

const InteractivePhoneNumber = styled(InteractiveText)`
  margin-top: 1.5rem;
  text-align: center;
  font-size: 24px;

  ${({ theme }) => theme.mq('lg')} {
    margin-top: 1rem;
  }
`;

const PhoneNumberHint = styled.span`
  display: block;
  margin-top: 0.25rem;
  color: ${({ theme }) => theme.colors.neutral.grey140};
  font-size: ${({ theme }) => theme.fontSize.xxs.size};
  text-align: center;
`;

const StyledOpeningTimesSchedule = styled(OpeningTimesSchedule)`
  width: 100%;
  max-width: 222px;
  align-self: center;
  font-size: ${({ theme }) => theme.fontSize.sm.size};
`;

const VoucherInfo = styled.div`
  ${getLayout};
  background-color: ${({ theme }) => theme.colors.neutral.grey20};
  margin-top: 2.5rem;
  padding: 1.5rem 1rem;
  text-align: center;

  ${({ theme }) => theme.mq('lg')} {
    margin-top: 2rem;
  }
`;

const VoucherExplanation = styled(SecondaryText)`
  margin-top: 1rem;
`;

export {
  Anchor,
  ContactInfo,
  InteractivePhoneNumber,
  PhoneNumberHint,
  PopoverWrapper,
  StyledOpeningTimesSchedule,
  VoucherExplanation,
  VoucherInfo,
};
